import * as React from 'react'
import { Chip, Box } from '@mui/material'
import { formatDate } from "@ui-seeker/utils"


export default function firstExtractionColumn() {
    return {
        name: 'firstExtraction', label: 'First extraction',
        options: {
            filter: false,
            customBodyRowRender: (value, row) => <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                { formatDate(value, {isString: true}) }
            </Box> 
        }
    }
}
